import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { map, startWith } from 'rxjs';

import { ConfigService, CurrencyService, currencySigns } from '@speedy/core';

@Component({
  standalone: true,
  imports: [AsyncPipe],
  selector: 'app-currency',
  templateUrl: './currency.component.html',
})
export class CurrencyComponent {
  private readonly configService = inject(ConfigService);
  private readonly currencyService = inject(CurrencyService);

  currentCurrency$ = this.currencyService.currentCurrency$.pipe(
    startWith(this.configService.getCurrency()),
    map((currency: string) => currencySigns[currency] ?? currency),
  );
}
